const FavoredButtonTemplate = () => `
  <i class="fa fa-heart" id="likeButton" aria-hidden="true" aria-label="unfavored this restaurant"></i>
`

export default FavoredButtonTemplate
